<script>
export default {
  data() {
    return {
      items: [
        {
          name: 'admin-account-list',
          title: this.$t('admin.as_list'),
        },
        {
          name: 'admin-account-catalog',
          title: this.$t('admin.account_info'),
        },
        {
          name: 'admin-account-balance-log-list',
          title: this.$t('admin.change_history'),
        },
      ],
    }
  },
}
</script>

<template>
  <ul
    v-if="$route.name !== 'admin-account-list'"
    :class="$style.localNavigation"
  >
    <router-link
      v-for="{ name, title } in items"
      :key="name"
      :to="{ name, params: $route.params }"
      :active-class="$style.on"
      tag="li"
    >
      <a href="#" @click.prevent>{{ title }}</a>
    </router-link>
  </ul>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
</style>
+
